import styled from 'styled-components';
import { TransparentButton } from '../transparent-button/TransparentButton';
export const ExportButtonWrapper = styled(TransparentButton) `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.1rem;
  border-radius: ${({ theme }) => theme.borderRadius.highL};
  background-color: ${({ theme }) => theme.colors.interactive.secondaryDisabled};
  cursor: pointer;
`;
//# sourceMappingURL=styles.js.map